import { render } from "./DynvibeAnimatedWordCloud.vue?vue&type=template&id=ee40c930"
import script from "./DynvibeAnimatedWordCloud.vue?vue&type=script&lang=js"
export * from "./DynvibeAnimatedWordCloud.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__